import React, { useMemo, useState } from 'react'
import '../RecordDetailsPage.scss'
import { GraniteDataGrid, Checkbox } from '@tecuity/granite-ui'
import format from 'date-fns/format'
import Portal from 'components/Portal/Portal'
import { Modal } from 'components/Modal/Modal'
import { useAppSetting } from '../../../Utilities/hooks'
import { GET_JOINT_VENTURE_ENTITIES } from 'requests'
import { useDispatch } from 'react-redux'
import { setErrorToast } from '../../../actions'
import { useHistory, useLocation } from 'react-router'

const PartiesPanel = ({ fieldSettings = {}, parties = [], title = '', showJVModal = false }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()
  const [pageSize, setPageSize] = useState(10)
  const [jointVentureModalOpen, setJointVentureModalOpen] = useState(false)
  const [jointVentureModalRows, setJointVentureModalRows] = useState([])

  const jointVentureModalTemplate = [
    {
      field: 'BusinessName',
      flex: 0.5,
      headerName: 'Business Name',
      disableColumnMenu: true,
    },
    {
      field: 'RecordNum',
      flex: 0.5,
      headerName: 'Record Num',
      disableColumnMenu: true,
    },
  ]

  const showJointVentureModal = useAppSetting('ShowJointVentureModal')

  const openJvModal = (jvNum) => {
    GET_JOINT_VENTURE_ENTITIES(
      jvNum,
      (res) => {
        setJointVentureModalRows(res.map((r, i) => ({ ...r, id: i })))
        setJointVentureModalOpen(true)
      },
      (err) => dispatch(setErrorToast(`Error getting joint venture entities`))
    )
  }

  const template = useMemo(() => {
    const temp = []
    Object.entries(fieldSettings).map(([key, val]) => {
      if (val.Enabled) {
        temp.push({
          field: key,
          flex: 0.5,
          headerName: val.DisplayName,
          disableColumnMenu: true,
          renderCell: (params) =>
            key === 'JointVentureGroupId' &&
            showJVModal &&
            showJointVentureModal.setting &&
            showJointVentureModal.setting.VALUE.toLowerCase() == 'true' ? (
              <div className="dlnTableLink" tabIndex={0} onClick={() => openJvModal(params.value)}>
                {params.value}
              </div>
            ) : key === 'RecordNum' && params.value.length > 3 ? (
              <div
                className="dlnTableLink"
                tabIndex={0}
                onClick={() => {
                  const parts = location.pathname.split('/')
                  history.push(`/recordDetails/${parts[2]}/${params.value}`)
                }}
              >
                {params.value}
              </div>
            ) : (
              params.value
            ),
        })
      }
      return null
    })
    return temp
  }, [parties, showJointVentureModal, fieldSettings])

  const ReadAddress = (address = {}) => {
    const showNewLine =
      (address.AddressLine1 || address.AddressLine2 || address.AddressLine3) &&
      (address.City || address.StateOrProvince || address.PostalCode)
    return (
      (address.AddressLine1 ? address.AddressLine1 : '') +
      (showNewLine ? '\n' : '') +
      (address.AddressLine2 ? address.AddressLine2 + '\n' : '') +
      (address.AddressLine3 ? address.AddressLine3 + '\n' : '') +
      (address.City ? address.City + ',' : '') +
      ' ' +
      (address.StateOrProvince ? address.StateOrProvince : '') +
      ' ' +
      (address.PostalCode ? address.PostalCode : '')
    )
  }

  const ReadValue = (fieldType, value) => {
    let curratedValue = value || value === false ? value : 'N/A'
    switch (fieldType) {
      case 0:
        break
      case 2:
        return ReadAddress(curratedValue)
      case 4:
        return value ? format(new Date(curratedValue), 'MM/dd/yyyy') : curratedValue
      case 16:
        return value ? value.Name : ''
      case 32:
        return <Checkbox checked={value} disabled={true} ariaLabel={`Checkbox`} />
      case 64:
        return value ? 'Good' : 'Bad'
      case 128:
        return value
      default:
        console.error('Uncertain Field Type: ' + fieldType + ' for value: ' + value)
        break
    }
    return value
  }

  const tableRows = useMemo(() => {
    const rows = parties.map((party, i) => {
      const row = {
        id: i,
      }
      Object.keys(fieldSettings).forEach((key) => {
        Object.assign(row, { [key]: ReadValue(fieldSettings[key].FieldType || 0, party[key]) })
      })
      return row
    })
    return rows
  }, [parties, fieldSettings])

  return (
    <div
      className="row"
      style={{ marginBottom: '80px', display: 'flex', flexDirection: 'row', gap: '20px' }}
    >
      <h2>{title}</h2>
      <GraniteDataGrid
        pageSize={pageSize}
        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
        rowsPerPageOptions={[10, 25, 50]}
        getRowId={(row) => row.id}
        columns={template}
        rows={tableRows}
      />
      <Portal isOpened={jointVentureModalOpen}>
        <Modal
          title="Joint Venture Entities"
          modalSize="large"
          autoHeight
          closeButton
          closeModal={() => setJointVentureModalOpen(false)}
        >
          <div style={{ padding: '20px 20px 50px', p: { marginBottom: '0 !important' } }}>
            <GraniteDataGrid
              rowsPerPageOptions={[10]}
              pageSize={10}
              getRowId={(row) => row.id}
              columns={jointVentureModalTemplate}
              rows={jointVentureModalRows}
            />
          </div>
        </Modal>
      </Portal>
    </div>
  )
}

export default PartiesPanel
